import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import BadgeCustom from '@core/components/badge-custom/BadgeCustom.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(BadgeCustom.name, BadgeCustom)
